import React from 'react';
import { TrashIcon } from './Icons/TrashIcon';
import { CreateIcon } from './Icons/CreateIcon';

/**
 * AdminMenuItem component renders a menu item with options to change, delete, or create sub-items.
 * 
 * @param {number} itemID - The ID of the menu item.
 * @param {string} itemText - The text to display for the menu item.
 * @param {function} onMenuChange - Function to handle menu item selection.
 * @param {function} onDelete - Function to handle the deletion of the menu item.
 * @param {function} onCreate - Function to handle the creation of a new sub-item.
 * @returns {JSX.Element} A menu item component with action icons.
 */
export function AdminMenuItem({ itemID, itemText, onMenuChange, onDelete, onCreate }) {

    /**
     * Handles the menu item selection.
     */
    const menuChange = () => {
        onMenuChange(itemID, itemText);
    };

    /**
     * Handles the deletion of the menu item.
     */
    const deleteItem = () => {
        onDelete(itemID);
    };

    /**
     * Handles the creation of a new sub-item.
     */
    const createItem = () => {
        onCreate(itemID);
    };

    return (
        <div className="menu-item" id={itemID} onClick={menuChange}>
            <h2>{itemText}</h2>
            <div className="menu-buttons">
                <button
                    type="button"
                    className="btn btn-default btn-sm"
                    onClick={createItem}
                    title="Skapa en fråga">
                    <CreateIcon />
                </button>
                <button
                    type="button"
                    className="btn btn-default btn-sm"
                    onClick={() => {
                        if (window.confirm("Är du säker på att du vill ta bort denna menyn och allt under denna?")) deleteItem()
                    }}
                    title="Ta bort undermeny"
                >
                    <TrashIcon />
                </button>

            </div>
        </div>
    );
}
